import { FontTTHoves } from 'assets/fonts/tt-hoves/FontTTHoves';
import { BrowserRouter } from 'react-router-dom';

import SharedProviders from './shared';

export default function Providers({ children }: { children?: React.ReactNode }) {
  return (
    <SharedProviders>
      <FontTTHoves />
      <BrowserRouter>{children}</BrowserRouter>
    </SharedProviders>
  );
}
